/* Remove page loading class after page loaded */
document.addEventListener('DOMContentLoaded', () => {
	$(".page-loading").each(function (index, element) {
        $(element).removeClass("page-loading");
    });
});
